import Container from '@/components/Container';
import SubContainer from '@/components/Container/SubContainer';
import { Suspense } from 'react';
import { Loading } from './components/loading';
import { ResourceHubSection } from './components/resource-hub-section';
// import { WheelSectionSection } from './components/wheel-section';
import { KeyDatesSection } from './components/key-dates-section';
import { ArticlesAndPodcastsSection } from './components/articles-and-podcasts-section';
import { LatestUpdatesSection } from './components/latest-updates-section';
import { useHome } from './hooks/useHome';
import { useResourceHubList } from '@/pages/resource-hub/list/hooks/useResourceHubList';

const HomePageComponent = () => {
  useHome();
  useResourceHubList();

  return (
    <>
      <LatestUpdatesSection />
      <div className="w-full bg-light-green py-sh-60">
        <Container className="!gap-0 md:!gap-0">
          <SubContainer>
            <KeyDatesSection />
          </SubContainer>
        </Container>
      </div>
      <Container className="py-sh-60">
        <SubContainer>
          <ResourceHubSection />
        </SubContainer>
      </Container>
      <div className="w-full bg-light-green py-sh-60 ">
        <Container>
          <SubContainer>
            <ArticlesAndPodcastsSection />
          </SubContainer>
        </Container>
      </div>
    </>
  );
};

const HomePage = () => {
  return (
    <Suspense fallback={<Loading />}>
      <HomePageComponent />
    </Suspense>
  );
};

export default HomePage;
